import AddTwoToneIcon from '@mui/icons-material/AddTwoTone'
import { Box, Button, Divider, List, ListItem, MenuItem, Typography } from '@mui/material'
import { Checkboxes, Select, TextField } from 'mui-rff'
import { Form, FormSpy } from 'react-final-form'
import { WbTableRowDeleteButton } from 'src/components/WbTable'
import { MasterWorkoutExerciseSet } from 'src/types/MasterWorkoutExercise'

interface MasterWorkoutExerciseSetsListProps {
	initialValues: MasterWorkoutExerciseSet[]
	onEdit: (idx: number, value: any) => void
	onRemove: (idx: number) => void
	onAdd: () => void
	canEdit: boolean
	enableRepsPerSet: boolean
	enableRirPerSet: boolean
}

const MasterWorkoutExerciseSetsList: React.FC<MasterWorkoutExerciseSetsListProps> = ({ initialValues, onEdit, onRemove, canEdit, onAdd, enableRepsPerSet, enableRirPerSet }) => {
	const rirValues = Array.from({ length: 11 }, (_, i) => i)

	return (
		<List sx={{ width: '100%', padding: 0, margin: 0 }}>
			{initialValues.map((set, idx) => {

				const formInitialValues = {
					...set,
					reps: set.reps ?? '', // if set.reps is null or undefined, use ''
					rir: set.rir ?? '',   // if set.rir is null or undefined, use ''
				}

				return (
					<ListItem key={set.displayOrder}>
						<Typography minWidth={65}>Set: {set.displayOrder + 1}</Typography>

						<Form
							onSubmit={onEdit}
							initialValues={formInitialValues}
							render={() => (
								<form style={{ width: '100%' }}>
									<fieldset disabled={!canEdit} style={{ border: 'none' }}>
										<Box display="flex" alignItems="center">
											<FormSpy
												onChange={({ values, dirty }) => {
													if (dirty) {
														const updatedValues = {
															...values,
															reps: values.reps === '' || values.reps == null ? null : Number(values.reps), // when the form value is '', convert it back to null
															rir: values.rir === '' ? null : values.rir,                                   // when the form value is '', convert it back to null
														}
														onEdit(idx, updatedValues)
													}
												}}
												subscription={{ values: true, dirty: true }}
											/>

											<TextField multiline type="text" label="note" name="note" />

											<Divider flexItem orientation="vertical" sx={{ mx: 2 }} />

											<Box display="flex" flexDirection="column" minWidth={115}>
												<Checkboxes
													name="isChild"
													data={{
														label: 'Is Child',
														value: set.isChild,
													}}
												/>
												<Checkboxes
													name="isToFailure"
													data={{
														label: 'To Failure',
														value: set.isToFailure,
													}}
												/>
												{enableRepsPerSet && (
													<TextField
														name="reps"
														label="Reps"
														type="number"
														inputProps={{
															min: 0,
															max: 100,
														}}
														sx={{ mb: 1 }}
													/>
												)}
												{enableRirPerSet && (
													<Select name="rir" label="RIR" sx={{ '.MuiSelect-select': { py: 1.5 } }}>
														<MenuItem value="">
															<em>None</em>
														</MenuItem>
														{rirValues.map((value) => (
															<MenuItem key={value} value={value}>
																{value}
															</MenuItem>
														))}
													</Select>
												)}
											</Box>
										</Box>
									</fieldset>
								</form>
							)}
						/>
						{canEdit && <WbTableRowDeleteButton onClick={() => onRemove(idx)} />}
					</ListItem>
				)
			})}
			{canEdit && (
				<ListItem>
					<Box width="100%" display="flex" justifyContent="center" alignItems="center">
						<Button variant="outlined" startIcon={<AddTwoToneIcon fontSize="small" />} onClick={onAdd}>
							Add Set
						</Button>
					</Box>
				</ListItem>
			)}
		</List>
	)
}

export default MasterWorkoutExerciseSetsList
